import { render } from "./NavButtons.vue?vue&type=template&id=337438d0&scoped=true"
import script from "./NavButtons.vue?vue&type=script&lang=js"
export * from "./NavButtons.vue?vue&type=script&lang=js"

import "./NavButtons.vue?vue&type=style&index=0&id=337438d0&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337438d0"]])

export default __exports__